// extracted by mini-css-extract-plugin
module.exports = {"container":"Timer_container__1PLhi","timeBox":"Timer_timeBox__rr-Sy"};